export const CEREALS = ['wheat', 'spelt', 'rye', 'corn', 'other', 'unknown'];
export const REFINEMENTS = ['white', 'partial', 'wholeGrain', 'unknown'];
/** Kinds of source of a flour property: label, mill sheet, lab, published reference, baker. */
export const FLOUR_SOURCE_KINDS = ['package', 'producer', 'lab', 'reference', 'personal'];
/** Bases a flour percentage may have (flours.md); a per-serving label value is converted. */
export const FLOUR_PCT_BASES = ['asIs', 'moisture14', 'dryMatter'];
export const FLOUR_PROPERTY_KEYS = [
    'proteinPct',
    'ashPct',
    'fallingNumberS',
    'alveographW',
    'alveographPL',
    'malted',
];
/** How each property is written: its value type and, for a number, its unit. */
export const FLOUR_PROPERTY_KINDS = {
    proteinPct: { type: 'pct', unit: 'pct' },
    ashPct: { type: 'pct', unit: 'pct' },
    fallingNumberS: { type: 'number', unit: 's' },
    alveographW: { type: 'number', unit: '1e-4 J' },
    alveographPL: { type: 'number' },
    malted: { type: 'boolean' },
};
//# sourceMappingURL=types.js.map